import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"
import { ShowCustomRepairTimeItemsRequest, ShowCustomRepairTimeItemsResponse } from "./models"

export function showCustomRepairTimeItems(body: ShowCustomRepairTimeItemsRequest) {
    const url = `${WebserviceUrl.BasketCustomRepairTimes}/ShowCustomRepairTimeItems`
    return ajaxAuth<ShowCustomRepairTimeItemsResponse>({ url, body }).then((response) => ({
        data: response?.customRepairTimeItems,
        pageIndex: body.pageIndex,
        endOfList: (response?.customRepairTimeItems?.length ?? 0) < body.pageSize,
    }))
}
